<!--@format-->
<template>
    <div class="account-profile-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Company Information</h3>
                <div class="svg-container widget-close-button" @click="closeWidget()">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <loading-svg v-if="isLoading" />
                <div v-else>
                    <app-input v-model="account.name" :label="'Name *'" />
                    <app-input v-model="account.website" :label="'Website'" />
                    <app-input v-model="account.email" :label="'Email'" />
                    <app-input v-model="account.phone" :label="'Phone'" />
                    <app-input v-model="account.address" :label="'Address'" />
                    <app-input v-model="account.address2" :label="'Address Line 2'" />
                    <app-input v-model="account.city" :label="'City'" />
                    <app-input v-model="account.state" :label="'State'" />
                    <app-input v-model="account.zip" :label="'Zip'" />
                    <app-input v-model="account.country" :label="'Country'" />
                    <app-input v-model="account.linkedinUrl" :label="'LinkedIn URL'" />
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="transparent-btn" @click="closeWidget()"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="save()"> Save </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const AppInput = () => import('@/components/common/app-input');
const AppButton = () => import('@/components/common/app-button');
const LoadingSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';
import { LogLevel } from "@/scripts/logger";

export default {
    name: 'account-profile-widget',

    components: {
        'widget-close-svg': WidgetCloseSvg,
        'app-input': AppInput,
        'app-button': AppButton,
        'loading-svg': LoadingSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            account: {
                id: this.widget.accountId,
                name: null,
                website: null,
                email: null,
                phone: null,
                address: null,
                address2: null,
                city: null,
                state: null,
                zip: null,
                country: null,
                linkedinUrl: null,
            },
            isLoading: false,
        };
    },

    created() {
        this.getData();
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        updateAccount() {
            this.loading = true;

            var request = {
                Name: this.account.name,
                Website: this.account.website,
                Email: this.account.email,
                Phone: this.account.phone,
                Address: this.account.address,
                Address2: this.account.address2,
                City: this.account.city,
                State: this.account.state,
                ZipCode: this.account.zip,
                Country: this.account.country,
                LinkedinUrl: this.account.linkedinUrl,
            };

            this.$api
                .put(`/api/Account/${this.account.id}/Profile`, request)
                .then(() => {
                    this.$helpers.showSuccessNotification(
                        `Successfully updated account information`
                    );
                    EventBus.$emit('account:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(`Failed to update account information`, { error });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        save() {
            if (this.account.name) {
                this.updateAccount();
            } else {
                this.$helpers.showFailNotification(`Please enter a name`, { level: LogLevel.INFO });
            }
        },

        getData() {
            this.loading = true;

            this.$api
                .get(`/api/Account/${this.account.id}/Profile`)
                .then((response) => {
                    this.account.name = response.data.Name;
                    this.account.website = response.data.Website;
                    this.account.email = response.data.Email;
                    this.account.phone = response.data.Phone;
                    this.account.address = response.data.Address;
                    this.account.address2 = response.data.Address2;
                    this.account.city = response.data.City;
                    this.account.state = response.data.State;
                    this.account.zip = response.data.ZipCode;
                    this.account.country = response.data.Country;
                    this.account.linkedinUrl = response.data.LinkedinUrl;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(`Failed to get account information`, { error });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style>
.account-profile-widget .loading-screen {
    width: 100%;
    text-align: center;
}

.account-profile-widget .app-input {
    margin-bottom: 15px;
}

.account-profile-widget .transparent-btn {
    background: transparent;
    color: #877d88;
}

.account-profile-widget .transparent-btn:hover {
    background: #e1e0e5;
}

@media only screen and (max-width: 720px) {
    .account-profile-widget.widget .widget-footer {
        padding: 0px 90px 0px 35px;
    }
}
</style>
